export default __webpack_public_path__ + "static/media/loading.bf21a1b4.png";